module.exports = __webpack_public_path__ + "img/itau.a5da8640.png";